"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatRepetitionIntervalText = formatRepetitionIntervalText;
exports.formatReviewAfterText = formatReviewAfterText;
exports.reviewIsPastDue = reviewIsPastDue;
exports.reviewsDueAtBeginningOfDay = reviewsDueAtBeginningOfDay;
exports.roundedRepetitionInterval = roundedRepetitionInterval;
exports.showExactReviewAfter = showExactReviewAfter;
function reviewsDueAtBeginningOfDay(reviewsDueAtBeginningOfDayValue) {
  return reviewsDueAtBeginningOfDayValue !== false;
}
function formatReviewAfterText(reviewAfter, reviewsDueAtBeginningOfDayValue) {
  if (!reviewAfter) {
    return '-';
  }
  if (reviewsDueAtBeginningOfDay(reviewsDueAtBeginningOfDayValue)) {
    return "".concat(reviewAfter.fullTextFormattedDateWithYear).concat(reviewAfter.relativeDays ? " (".concat(reviewAfter.relativeDays, ")") : '');
  }
  return "".concat(reviewAfter.formattedDateWithYearAndTime || '-').concat(reviewAfter.relativeTime ? " (".concat(reviewAfter.relativeTime, ")") : '');
}
function reviewIsPastDue(reviewAfter, reviewsDueAtBeginningOfDayValue) {
  var reviewAfterDate = (reviewAfter === null || reviewAfter === void 0 ? void 0 : reviewAfter.dateObj) || (reviewAfter === null || reviewAfter === void 0 ? void 0 : reviewAfter.date);
  if (!reviewAfterDate) {
    return false;
  }
  var now = new Date();
  var cutoff = reviewsDueAtBeginningOfDay(reviewsDueAtBeginningOfDayValue) ? new Date(now.setHours(23, 59, 59, 999)) : new Date();
  return new Date(reviewAfterDate) < cutoff;
}
function showExactReviewAfter(reviewsDueAtBeginningOfDayValue) {
  return !reviewsDueAtBeginningOfDay(reviewsDueAtBeginningOfDayValue);
}
function roundedRepetitionInterval(repetitionInterval, reviewsDueAtBeginningOfDayValue) {
  var number = Number(repetitionInterval);
  if (!Number.isFinite(number) || number <= 0) {
    return 0;
  }
  if (reviewsDueAtBeginningOfDay(reviewsDueAtBeginningOfDayValue)) {
    return Math.round(number);
  }
  return Math.round(number * 10) / 10;
}
function formatRepetitionIntervalText(repetitionInterval, reviewsDueAtBeginningOfDayValue) {
  var number = roundedRepetitionInterval(repetitionInterval, reviewsDueAtBeginningOfDayValue);
  if (!number) {
    return '-';
  }
  return "".concat(number, " Day").concat(number === 1 ? '' : 's');
}